import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { CheckCircle2, Loader2, ArrowRight } from "lucide-react";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [status, setStatus] = useState({ payment_status: "pending" });
  const [polling, setPolling] = useState(true);
  const { checkAuth } = useAuth();

  useEffect(() => {
    if (!sessionId) { setPolling(false); return; }
    let attempts = 0;
    const iv = setInterval(async () => {
      attempts += 1;
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        setStatus(data);
        if (data.payment_status === "paid" || attempts >= 10) {
          clearInterval(iv);
          setPolling(false);
          await checkAuth();
        }
      } catch {
        if (attempts >= 10) { clearInterval(iv); setPolling(false); }
      }
    }, 2000);
    return () => clearInterval(iv);
  }, [sessionId, checkAuth]);

  const paid = status.payment_status === "paid";

  return (
    <div className="max-w-lg mx-auto py-16" data-testid="payment-success-page">
      <Card className="p-10 bg-card border-border text-center">
        {polling ? (
          <>
            <Loader2 className="h-14 w-14 mx-auto text-cyan-400 animate-spin mb-4" />
            <h1 className="font-display text-2xl font-bold mb-2">Confirmation du paiement…</h1>
            <p className="text-muted-foreground text-sm">Nous vérifions le statut avec Stripe.</p>
          </>
        ) : paid ? (
          <>
            <CheckCircle2 className="h-14 w-14 mx-auto text-emerald-400 mb-4" />
            <h1 className="font-display text-2xl font-bold mb-2">Paiement confirmé !</h1>
            <p className="text-muted-foreground text-sm mb-6">Votre abonnement est actif. Bienvenue dans la version premium.</p>
            <Link to="/dashboard"><Button className="bg-cyan-500 hover:bg-cyan-400 text-slate-950" data-testid="go-dashboard-after-pay">
              Ouvrir mon tableau de bord <ArrowRight className="h-4 w-4 ml-2" />
            </Button></Link>
          </>
        ) : (
          <>
            <h1 className="font-display text-2xl font-bold mb-2">En attente de confirmation</h1>
            <p className="text-muted-foreground text-sm mb-6">Le paiement n'est pas encore confirmé. Recharger la page dans quelques instants.</p>
            <Link to="/tarifs"><Button variant="outline">Retour aux tarifs</Button></Link>
          </>
        )}
      </Card>
    </div>
  );
}
